import React from 'react';

const EntityScoreValuesInfo = ({hideEntityScoreValuesInfo}) => {

  return (
    <div className="risk-classification-container hidePopup" onClick={hideEntityScoreValuesInfo} id="EntityScoreValuesInfo">
      <div className="risk-classification-content">
        <p>View how key factors influence the risk profile of each selected entity. The spider chart visualizes feature importance across risk-related attributes.</p>
      </div>
    </div>
  )
}

export default EntityScoreValuesInfo;